import { call, put, select } from 'redux-saga/effects';
import { suggestionActions } from 'store/data/suggestion';
import { deleteSuggestion } from 'store/glue/operation/deleteSuggestion';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';
import * as constants from './constants';
import * as improvementsSelectors from './selectors';

// Deselects the suggestion if it is currently selected, then either:
//  - drops the unsaved mock placeholder from the store directly, or
//  - delegates to the deleteSuggestion operation which calls the API and
//    removes the entity from the store on success.
export function* startDeleteSuggestionSaga(
  action: ActionType<typeof improvementsActions.startDeleteSuggestion>,
) {
  function* saga() {
    const { suggestionId } = action.payload;

    const selectedSuggestionId: ReturnType<
      typeof improvementsSelectors.selectedSuggestionId
    > = yield select(improvementsSelectors.selectedSuggestionId);

    if (selectedSuggestionId === suggestionId)
      yield put(improvementsActions.setSelectedSuggestionId(null));

    // The mock placeholder lives only in the store; nothing to delete server-side.
    if (suggestionId === constants.MOCKED_SUGGETION_ID) {
      yield put(suggestionActions.remove(suggestionId));
      return;
    }

    yield call(deleteSuggestion, { suggestionId });
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
